"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusHelper = void 0;
var auth_status_1 = require("@jawbreaker/auth-status");
var either_1 = require("@jawbreaker/either");
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var StatusHelper = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function StatusHelper(getNow) {
        if (getNow === void 0) { getNow = function () { return Date.now(); }; }
        this.getNow = getNow;
    }
    StatusHelper.prototype.isExpired = function (data) {
        return data.exp * 1000 <= this.getNow();
    };
    StatusHelper.prototype.parse = function (value) {
        if (value === undefined) {
            return { isValid: false, reason: "AUTH_STATE_PARSE_NO_COOKIE" };
        }
        var result = jsonwebtoken_1.default.decode(value);
        if (result === null) {
            return { isValid: false, reason: "AUTH_STATE_PARSE_INVALID_JWT_STRING" };
        }
        var decodeResult = auth_status_1.Status.decoder.decode(result);
        if (either_1.Either.isLeft(decodeResult)) {
            return {
                isValid: false,
                reason: "AUTH_STATE_PARSE_INVALID_JSON_STRUCTURE",
            };
        }
        return { isValid: true, payload: decodeResult.right };
    };
    return StatusHelper;
}());
exports.StatusHelper = StatusHelper;
